<template>
  <div style="min-height: 125px">
    <b-card style="min-height: 125px">
      <filter-swapper :buttons="buttons" :controlHeightButtons="controlHeight">
        <template #slot1>
          <form-render 
          :form.sync="formSelect" 
          :key="keyFormRender" 
          :fields="fieldsSelect" 
          @send="filterList"
          :buttonSend="buttonSend"
          ref="formFilter"
          containerButtonsClass="col-sm-12 col-md-7 col-lg-4 col-xl-3 container-button mt-2" class="mb-2">
            <template #buttons>
              <b-button variant="outline-light" v-b-tooltip.hover title="Limpiar filtros" class="ml-1" @click="cleanFilter"><feather-icon icon="RefreshCwIcon"/></b-button>
            </template>
          </form-render>
        </template>
      </filter-swapper>
      <div v-if="rows.length===0 && !loading.marketcenters" class="d-flex flex-column justify-content-center align-items-center" style="height: 470px">
        <div>
          <feather-icon icon="FileTextIcon" size="52" style="color:#B9B9C7"/>
        </div>
        <div class="text-wrap text-center my-1" style="width: 36rem;font-size:14px;color:#B9B9C7">
          Utiliza los selectores disponibles en la parte superior
          para realizar una búsqueda eficiente y acceder a la información deseada.
        </div>
      </div>
      <div v-show="!loading.total" class="table-listmarkeplace">
        <table-render
          :schema.sync="schema"
          :rows="rows"
          :actions="actions"
          :loading="loading.marketcenters"
          :stickyHeader="`calc(100vh - 2.5rem)`"
          id="listMarketplace"
          :tableClass="'with-scroll'"
          :striped="true"
          :showCheckboxes="false"
        >
        </table-render>
      </div>
      <div class="table-render-skeleton mt-2" v-if="loading.marketcenters">
        <b-skeleton-table :rows="8" :columns="4" :table-props="{}" />
      </div>
    </b-card>
    <modal-markeplace
    id="marketplaceModal"
    :formConfig="formConfig"
    :fieldsConfig="fieldsConfig"
    @postConfigFields="postConfigFields"
    @deleteIntegration="deleteIntegration"
    :isMeli="isMeli"
    ></modal-markeplace>
  </div>
</template>
<script>
import ModalMarkeplace from './ModalMarkeplace.vue'
import { mapGetters } from 'vuex'
export default {
  components: { ModalMarkeplace },
  data() {
    return {
      controlHeight: { class: 'row mb-2 spacing-label-field'},
      buttonSend: {title: 'Buscar', icon: 'SearchIcon', color: 'warning'},
      buttons: [],
      keyFormRender: 0,
      schema: [],
      actions: [],
      rows: [],
      myWarehouses: [],
      idMarketplace: undefined,
      rowSelect: undefined,
      fieldsSelect: [],
      formSelect: {},
      fieldsConfig: [],
      formConfig: {},
      fields: [],
      shipper_id: null,
      country_id: null,
      organizationId: null,
      marketcenter_cod: null,
      isMeliConfigurated: false,
      loadingFields: {
        organizations: true,
        shippersByOrganization: true
      },
      loading: {
        marketcenters: false,
        warehouses:false,
        total: true,
        second: true
      },
      organization_type_id: null
    }
  },
  computed: {
    ...mapGetters({
      mySession: 'getSession',
      organizations: 'getOrganizations',
      shippersByOrganization: 'getShippersByOrganization',
      generalLoading: 'getLoading',
      marketcenters: 'getMarketcenters',
      warehouses: 'getWarehouses',
      fieldsMarketcenter: 'getFieldsMarketcenter',
      countries: 'getCountries'
    }),
    isMeli() {
      const regex = /^ML/gm
      return !!this.marketcenter_cod?.match(regex)
    }
  },
  watch: {
    fieldsMarketcenter(value) {
      this.fields = value
      this.fieldsConfig = value.map(({field, label, type, ...rest}) => {
        const typeField = this.getCustomizedField(field, label, type, rest)
        return {
          ...typeField,
          name: field,
          containerClass: 'col-sm-12 col-md-6 container-info',
          validation: rest?.validation
        }
      })
      this.formConfig = value.reduce((target, key) => {
        const value = this.getValueSpecialField(key)
        target[key.field] = value
        
        return target
      }, {})
    },
    marketcenters() {
      this.rows = this.marketcenters.map(({id, name, code, created_at}) => {
        return {
          id,
          name,
          code,
          created_at: created_at.split(' ')[0]
        }
      })
      this.loading.second = false
    },
    warehouses() {
      this.myWarehouses = this.warehouses.map((d) => ({ id: d.code, text: d.name }))
    },
    idMarketplace(newValue) {
      this.rowSelect = this.rows.find(r => r.id === newValue)
    },
    mySession() {
      if (this.mySession.id) this.setInitialData()
    },
    organizations () {
      this.setSelectOptions('organization_id', { options: this.organizations.rows })
    },
    shippersByOrganization () {
      const shipperOptions = this.shippersByOrganization.map((shipper) => ({...shipper, name: shipper.name1, text: shipper.name1 }))
      this.setSelectOptions('shipper_id', { options: shipperOptions })
    },
    generalLoading: {
      handler () {
        this.loadingFields.organizations = !!this.generalLoading.getOrganizations
        this.loadingFields.shippersByOrganization = !!this.generalLoading.getShippersByOrganization
        this.loading.marketcenters = !!this.generalLoading.getMarketcenters

        this.setSkeletonField('organization_id', this.loadingFields.organizations)
        this.setSkeletonField('shipper_id', this.loadingFields.shippersByOrganization)
      },
      deep: true
    },
    loading: {
      handler () {
        const prevTotal = this.loading.total
        this.loading.total = !Object.keys(this.loading).filter(key => key !== 'total').every(key => !this.loading[key])
        if (prevTotal !== this.loading.total) this.keyFormRender++
      },
      deep: true
    }
  },
  mounted () {
    this.setInitialData()
  },
  methods: {
    setInitialData () {
      if (['admin', 'superadmin'].includes(this.$session.get('cas_user').role)) {
        this.fieldsSelect = [
          {fieldType: 'FieldSelect', name: 'country_id', addFlags:true, label: this.$t('País'), useLabel: true, change: this.onChangeCountry},
          {fieldType: 'FieldSelect', name: 'organization_id', label: 'eCommerce/Marketplace', useLabel: true, clearable: true, change: this.changeOrganization, validation: 'required', dependency: 'country_id'}
        ]
        this.setSelectOptions('country_id', { options: this.countries })
      } else if (this.$session.get('cas_user').role === 'marketplace') {
        this.organizationId = this.$session.get('cas_user').organization.id
        this.changeOrganization('Organization', this.$session.get('cas_user').organization)
      } else {
        this.shipper_id = this.$session.get('cas_user')?.shipper?.id
        this.filterList()
      }
      this.schema = [
        {label: 'Id', key: 'id', class: ['hidden']},
        {label: 'Nombre', key: 'name', sortable: true, style: { width: '20%'}},
        {label: 'Código', key: 'code', sortable: true, style: { width: '15%'}},
        {label: 'Fecha de creación', key: 'created_at', sortable: true, style: { width: '15%'}},
        {label: 'Acciones', key: 'actions', class: ['text-center']}
      ]
      this.actions = [
        {action: id => this.getFieldsMarketcenter(id), icon: 'ToolIcon', color: 'success', text: 'Configurar'}
      ]
    },
    getCustomizedField (field, label, type, rest) {
      switch (type) {
      case 'checkbox':
        return { fieldType:'FieldCheckbox', options: [{id: true, text: label}]}
      case 'select':
        return field === 'warehouse_code' ? { fieldType:'FieldSelect', options: this.myWarehouses, label} : { fieldType:'FieldSelect', options: rest.options.map((op) => ({ id: op.code, text: op.name })), label}
      case 'multiselect':
        if (rest?.message) return { fieldType:'FieldSelect', options: rest?.options?.map((op) => ({ id: op.value, text: op.title })) || [], label, multiple: true, info: `<div class="alert"> <i class="fa fa-info-circle text-primary"></i> ${rest?.message}</div >` }
        return { fieldType:'FieldSelect', options: rest?.options?.map((op) => ({ id: op.value, text: op.title })) || [], label, multiple: true }
      case 'textarea':
        return { fieldType:'FieldTextarea', label}
      default:
        return { fieldType: 'FieldInput', label}
      }
    },
    getValueSpecialField (key) {
      switch (key.type) {
      case 'checkbox':
        return !!key.value
      case 'select':
        return key.field === 'warehouse_code' ? this.myWarehouses?.find((w) => w.value === key.id) || {} : key.options?.map((el) => ({id: el.code, text: el.name}))?.find((w) => w.id === key.value)
      case 'multiselect':
        return key.options.filter((v) => key.value.some((value) => value === v.value)).map((v) => ({id: v.value, text:v.title})) || []
      case 'textarea':
        return key.value
      default:
        return key.value
      }
    },
    getPostValueSpecialField (rest, form) {
      switch (rest.type) {
      case 'checkbox':
        return !!form[rest.field]
      case 'select':
        return form[rest.field]?.id ?? ''
      case 'multiselect':
        return form[rest.field]?.map((v) => v.id) || []
      default:
        return form[rest.field] ?? ''
      }
    },
    filterList(form) {
      this.shipper_id = form?.shipper_id?.id ?? this.shipper_id
      this.getMarketcenters()
      if (this.shipper_id) this.getWarehouses(this.shipper_id)
    },
    getMarketcenters() {
      const data = {
        name: 'getMarketcenters',
        params: { shipper_id: this.shipper_id }
      }
      this.$store.dispatch('fetchService', data)
    },
    getOrganizationsFetch(country_id) {
      const data = { 
        name: 'getOrganizations',
        queryParams: {country_id, simplified: true }
      }
      this.$store.dispatch('fetchService', data)
    },
    getOrganizationByShipper(organization_id) {
      const data = { 
        name: 'getShippersByOrganization',
        queryParams: {page: 1, paginate_by: 99999 },
        params: { organization_id },
        onError: () => {
          this.setSelectOptions('shipper_id', { options: [] })
          this.setSkeletonField('shipper_id', false)
        },
        hideAlert: true
      }
      this.$store.dispatch('fetchService', data)
    },
    getWarehouses(shipper_id) {
      const data = { 
        name: 'getWarehouses',
        params: {shipper_id},
        msg: this.$t('warehouses')
      }
      this.$store.dispatch('fetchService', data)
    },
    getFieldsMarketcenter(id) {
      this.marketcenter_cod = this.rows.find(r => r.id === id).code
      const data = { 
        name: 'getFieldsMarketcenter',
        params: {marketcenter_cod: this.marketcenter_cod, shipper_id: this.shipper_id},
        onSuccess: () => this.$bvModal.show('marketplaceModal')
      }
      this.$store.dispatch('fetchService', data)
    },
    postConfigFields(form) {
      this.isMeliConfigurated = false
      const queryParams = this.fields.map((rest) => {
        const newValue = this.getPostValueSpecialField(rest, form)
        
        return {
          ...rest,
          value: newValue
        }        
      })
      const data = { 
        name: 'postConfigMarketcenter',
        params: {marketcenter_cod: this.marketcenter_cod, shipper_id: this.shipper_id},
        queryParams,
        onSuccess: (d) => { 
          this.isMeliConfigurated = d.data.redirect
          this.$bvModal.hide('marketplaceModal')
          this.isMeliIntegration(form) 
        }
      }
      this.$store.dispatch('fetchService', data)
    },
    isMeliIntegration(params) {
      const logicType = JSON.stringify(params?.logistic_type_active?.map((e) => e.id)) ?? '[]'
      const urlMeli = `https://ottawa.enviame.io/v1/webhook/mercado-libre/authenticate?api_key=${params.api_key_enviame}&company=${this.shipper_id}&warehouse_code=${params?.warehouse_code?.id}&marketcenter_code=${params.marketcenter_code}&logistic_type_active=${logicType}`
      const regex = /^ML/gm
      if (this.marketcenter_cod.match(regex) && this.isMeliConfigurated) window.open(urlMeli, '_blank')
    },
    deleteIntegration() {
      const data = { 
        name: 'deleteIntegrationMkc',
        params: {marketcenter_cod: this.marketcenter_cod, shipper_id: this.shipper_id},
        onSuccess: () => { 
          this.$bvModal.hide('marketplaceModal')
        }
      }
      this.$store.dispatch('fetchService', data)
    },
    changeShipper() {
      this.keyFormRender++
    },
    cleanFilter (e) {
      this.formSelect = {}
    },
    changeOrganization (name, value) {
      const { organization_type } = value
      this.organization_type_id = organization_type.id
      this.organizationId = value.id
      this.fieldsSelect = this.fieldsSelect.filter((field) => field.name !== 'shipper_id')
      if (organization_type.id === 1 && ['admin', 'superadmin'].includes(this.$session.get('cas_user').role)) {
        this.getOrganizationByShipper(this.organizationId)
        this.cleanFields(['shipper_id'])
        this.fieldsSelect.push({fieldType: 'FieldSelect', name: 'shipper_id', label: 'Seller', useLabel: true, placeholder: 'Nombre de la empresa', dependency: 'organization_id', change: this.changeShipper, validation: 'required'})
      } else if (organization_type.id === 1 && ['marketplace'].includes(this.$session.get('cas_user').role)) {
        this.getOrganizationByShipper(this.organizationId)
        this.cleanFields(['shipper_id'])
        this.fieldsSelect.push({fieldType: 'FieldSelect', name: 'shipper_id', label: 'Seller', useLabel: true, placeholder: 'Nombre de la empresa', change: this.changeShipper, validation: 'required'})
      } else {
        delete this.formSelect.shipper_id
        this.shipper_id = this.organizationId
      }
    },
    onChangeCountry(name, value) {
      this.getOrganizationsFetch(value?.id ?? this.country_id)
      this.cleanFields(['shipper_id', 'organization_id'])
    },
    setSkeletonField(name, value) {
      const index = this.fieldsSelect.findIndex(el => el.name === name)
      if (index !== -1) this.fieldsSelect[index].useSkeleton = value
    },
    setSelectOptions (name, { options }) {
      const index = this.fieldsSelect.findIndex(el => el.name === name)
      if (index !== -1) {
        this.fieldsSelect[index].options = options
        this.fieldsSelect[index].disabled = false
      }
      this.keyFormRender++
    },
    cleanFields(array) {
      array.forEach((el) => this.formSelect[el] = null)
      this.keyFormRender++
    }
  }
}
</script>
<style>
  .table-listmarkeplace .table-render-skeleton {
    overflow-x: hidden !important;
  }
  .alert {
    margin-top: 5px;
    padding: 10px;
    background-color: #E6EEFA;
    border: #D0E2F8 2px solid;
  }
</style>

